/**
 * POST payload for endpoint /api/users/{domain}/createPrivilegeAccount
 */
export class CreatePrivilegeAccountRequest {
    steward: string;
}